var api = require("!../../../../../../app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../app/node_modules/css-loader/dist/cjs.js??ref--6-1!../../../../../../app/node_modules/postcss-loader/src/index.js??ref--6-2!../../../../../../app/node_modules/sass-loader/dist/cjs.js??ref--6-3!./purchase-modal.styles.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};